import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import DashboardLayout from '../../app/layouts/dashboard';
import LogoOnlyLayout from '../../app/layouts/LogoOnlyLayout';
import GuestGuard from '../../app/guards/GuestGuard';
import AuthGuard from '../../app/guards/AuthGuard';
import { routeKeys } from '../utils/constants';
import { removeBackSlash } from '../utils/helpers';

const Bookings = lazy(() => import('../../modules/bookings/Bookings'));
const Dashboard = lazy(() => import('../../modules/dashboard/Dashboard'));
const Login = lazy(() => import('../../modules/auth/Login'));
const CoursesMain = lazy(() => import('../../modules/learning/Modules'));
const Course = lazy(() => import('../../modules/learning/components/Courses'));
const Page403 = lazy(() => import('../../modules/auth/Page403'));
const Page404 = lazy(() => import('../../modules/auth/Page404'));
const Page500 = lazy(() => import('../../modules/auth/Page500'));
const Register = lazy(() => import('../../modules/auth/Register/Register'));
const ResetPassword = lazy(() => import('../../modules/auth/ResetPassword'));
const Students = lazy(() => import('../../modules/students/Students'));
const SupportTicketList = lazy(() => import('../../modules/support-tickets/SupportTicketList'));
const SupportTicketDetails = lazy(() => import('../../modules/support-tickets/SupportTicketDetails'));

export const routes = [
  {
    path: removeBackSlash(routeKeys.auth),
    children: [
      {
        path: removeBackSlash(routeKeys.login),
        element: (
          <GuestGuard>
            <Login />
          </GuestGuard>
        ),
      },
      {
        path: removeBackSlash(routeKeys.register),
        element: (
          <GuestGuard>
            <Register />
          </GuestGuard>
        ),
      },
      { path: removeBackSlash(routeKeys.unprotected), element: <Login /> },
      { path: removeBackSlash(routeKeys.register), element: <Register /> },
      { path: removeBackSlash(routeKeys.resetPassword), element: <ResetPassword /> },
    ],
  },
  {
    path: '',
    element: (
      <AuthGuard>
        <DashboardLayout />
      </AuthGuard>
    ),
    children: [
      { path: routeKeys.dashboard, element: <Dashboard /> },
      { path: routeKeys.students, element: <Students /> },
      { path: routeKeys.bookings, element: <Bookings /> },

      {
        path: removeBackSlash(routeKeys.modules),
        children: [
          { index: true, element: <Navigate to={removeBackSlash(routeKeys.modules)} replace /> },
          { path: removeBackSlash(routeKeys.modules), element: <CoursesMain /> },
          { path: removeBackSlash(routeKeys.advancedDescriptQuant), element: <Course /> },
          { path: removeBackSlash(routeKeys.closeOutProcess), element: <Course /> },
          { path: removeBackSlash(routeKeys.costInfo), element: <Course /> },
          { path: removeBackSlash(routeKeys.disputeRes), element: <Course /> },
          { path: removeBackSlash(routeKeys.financialFeasibility), element: <Course /> },
          { path: removeBackSlash(routeKeys.lifeCyleCosting), element: <Course /> },
          { path: removeBackSlash(routeKeys.procurment), element: <Course /> },
          { path: removeBackSlash(routeKeys.propertyLaw), element: <Course /> },
          { path: removeBackSlash(routeKeys.qualityAssurance), element: <Course /> },
          { path: removeBackSlash(routeKeys.research), element: <Course /> },
          { path: removeBackSlash(routeKeys.riskManagement), element: <Course /> },
          { path: removeBackSlash(routeKeys.strategicPlanning), element: <Course /> },
        ],
      },
      {
        path: removeBackSlash(routeKeys.support),
        children: [
          { index: true, element: <Navigate to={removeBackSlash(routeKeys.list)} replace /> },
          { path: removeBackSlash(routeKeys.list), element: <SupportTicketList /> },
          { path: ':id/details', element: <SupportTicketDetails /> },
        ],
      },
    ],
  },
];

export const generalRoutes = [
  {
    path: removeBackSlash(routeKeys.auth),
    children: [
      {
        path: removeBackSlash(routeKeys.login),
        element: (
          <GuestGuard>
            <Login />
          </GuestGuard>
        ),
      },
      { path: removeBackSlash(routeKeys.unprotected), element: <Login /> },
      { path: removeBackSlash(routeKeys.resetPassword), element: <ResetPassword /> },
    ],
  },
  {
    path: '*',
    element: <LogoOnlyLayout />,
    children: [
      { path: removeBackSlash(routeKeys.page500), element: <Page500 /> },
      { path: removeBackSlash(routeKeys.page404), element: <Page404 /> },
      { path: removeBackSlash(routeKeys.page403), element: <Page403 /> },
      { path: '*', element: <Navigate to={routeKeys.page404} replace /> },
    ],
  },
  {
    path: '/',
    element: (
      <AuthGuard>
        <DashboardLayout />
      </AuthGuard>
    ),
    children: [{ element: <Dashboard />, index: true }],
  },
  { path: '*', element: <Navigate to={routeKeys.page404} replace /> },
];

// TO-DO: Setup student Support

export const studentRoutes = [
  {
    path: '',
    element: (
      <AuthGuard>
        <DashboardLayout />
      </AuthGuard>
    ),
    children: [
      { path: routeKeys.dashboard, element: <Dashboard /> },
      { path: routeKeys.bookings, element: <Bookings /> },
      { path: routeKeys.modules, element: <CoursesMain /> },
      {
        path: routeKeys.support,
        children: [
          { index: true, element: <Navigate to="list" replace /> },
          { path: 'list', element: <SupportTicketList /> },
          { path: ':id/details', element: <SupportTicketDetails /> },
        ],
      },
    ],
  },
];
